import { Component, OnInit } from '@angular/core';
import { Sim, SimWithUsage } from '../../models/sim';
import { SimDataService } from '../../services/sim-data.service';
import { Observable, combineLatest } from 'rxjs';
import { StateService } from '@uirouter/core';
import { map } from 'rxjs/operators';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-sims-overview',
  template: require('./sims-overview.component.html'),
  styles: [require('./sims-overview.component.sass')]
})
export class SimsOverviewComponent implements OnInit {

  projectId: number;
  sims$: Observable<SimWithUsage[]>;

  constructor(
    private simDataService: SimDataService,
    private $state: StateService,
    private datePipe: DatePipe
  ) { 
    this.projectId = this.$state.params && this.$state.params.projectId;

    const sims$ = this.simDataService.getAllSims(this.projectId);
    const operators$ = this.simDataService.getAllOperators(this.projectId);
    
    this.sims$ = combineLatest([sims$, operators$]).pipe(
      map(([sims,  operators]) => {
        return sims.map(sim => {
          const operator = operators.find(operator => operator.code === String(sim.simConfig.operatorCode));
          return {
            ...sim,
            simConfig: {
              ...sim.simConfig,
              operator: operator && operator.network
            }
          }
          
        })
      }))
  }

  ngOnInit(): void {
  }

  viewSimDetails(sim: Sim | SimWithUsage) {
    this.$state.go('sim-overview-detail', {
      projectId: sim.projectId, 
      iccid: sim.iccid,
      from: this.datePipe.transform(sim.simConfig.currentBeginPeriod, "yyyy-MM-dd'T'HH:mm:ssZZZZZ"),
      to: this.datePipe.transform(sim.simConfig.currentEndPeriod, "yyyy-MM-dd'T'HH:mm:ssZZZZZ")
    });
  }

}
